module.exports = __webpack_public_path__ + "images/2-i9c74f69d3574eec7dbe12bc203634659.svg";